/**
 * @fileoverview GET handler for the "/engagement/content_blocks/names" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementContentBlocksNames } from "./constants";
import type { EngagementContentBlocksNamesResult } from "./types";
import { isEngagementContentBlocksNamesResult } from "./validators";

export const getEngagementContentBlocksNames = reactQueryFetcherAdapter(
  engagementContentBlocksNames,
  (signal: AbortSignal, query: string, limit: number): Promise<EngagementContentBlocksNamesResult> => {
    return fetch("/engagement/content_blocks/names", "GET", { query, limit }, { signal });
  },
  isEngagementContentBlocksNamesResult
);
